<template>
  <v-autocomplete
    v-if="items"
    v-model="model"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    item-text="formattedAddress"
    item-value="formattedAddress"
    label="Adresse suchen"
    return-object
    :no-filter="true"
    ref="input"
    @keyup.enter="submit"
  ></v-autocomplete>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'GeoSearch',
    data: () => ({
      descriptionLimit: 60,
      entries: [],
      items: [],
      isLoading: false,
      model: null,
      search: null,
      lastAccessed: new Date(),
      count: 0,
    }),

    computed: {},

    watch: {
      model() {
        if (!this.model) {
          return;
        }

        this.isLoading = true;
        const value = this.model.formattedAddress;

        fetch(`https://dev.virtualearth.net/REST/v1/Locations?q=${value}&key=AjI3mr1zpwgCpkEXxAFKLGEQjiovDVvCfcQzWQ` +
          `R5WQ9UhnbMHlEKAk_ZemdyQFLT`)
          .then((res) => res.json())
          .then((res) => {
            console.log(res);
            const gps = res.resourceSets[0].resources[0].point.coordinates;
            const name = res.resourceSets[0].resources[0].name;
            this.chooseAddress({gps, name});
            this.focusOn(gps);
          })
          .finally(() => {
            this.isLoading = false;
            this.model = null;
            this.search = '';
          });
      },
      search(val) {
        if (!val || val.length <= 3) {
          return;
        }
        // Items have already been requested
        // if (this.isLoading) {
        //   return;
        // }

        this.isLoading = true;

        // Lazily load input items
        fetch(`https://dev.virtualearth.net/REST/v1/Autosuggest?query=${val}&` +
          `key=AjI3mr1zpwgCpkEXxAFKLGEQjiovDVvCfcQzWQR5WQ9UhnbMHlEKAk_ZemdyQFLT&` +
          `countryFilter=AT&includeEntityTypes=Address,Place,Business`)
          .then((res) => res.json())
          .then((res) => {
            this.entries = res.resourceSets[0].resources[0].value;
            this.count = res.resourceSets[0].resources[0].value.length;
          })
          .finally(() => (this.isLoading = false));
      },
      entries() {
        this.items = this.entries.map((entry) => entry.address);
      },
    },
    methods: {
      ...mapActions({
        chooseAddress: 'map/chooseAddress',
        focusOn: 'map/centerOnBbox',
      }),
      submit() {
        this.model = this.items[0];
        this.$refs.input.blur();
      },
    },
  };
</script>

<style scoped>

</style>
